





































import { vxm } from '../../store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 7000,
});

@Component({
  name: 'DeActivateAllJobAlerts',
  components: {},
})
export default class DeActivateAllJobAlerts extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private successString: string = '';
  private displayMessage: string = '';
  private errorFlag: boolean = false;
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public deactivateJobAlerts(hash) {
    vxm.jobs.deactivateJobAlerts(hash).then((res) => {
      if (res === true) {
        this.$wlToastr(
          'success',
          this.$t(this.successString),
          'Your alerts have been paused. You will no longer receive job alerts for your search criteria.',
        );
        console.log(this.successString);
        this.displayMessage =
          'Your alerts have been paused. You will no longer receive job alerts for your search criteria.';
        return true;
      } else {
        this.$wlToastr(
          'error',
          this.$t(this.errorString),
          'Error! Could not deactivate job alerts!',
        );
        this.displayMessage = 'Error! Could not deactivate job alerts!';
        this.errorFlag = true;
        return false;
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  mounted() {
    const hashCode = this.$route.params.code;
    console.log('code is:' + hashCode);
    this.deactivateJobAlerts(hashCode);
  }
}
